export type DnFieldGroup = 'root' | 'concreteMetadata' | 'mixer';
export type DnInputType = 'text' | 'number' | 'date' | 'time';

export interface DnFieldDef {
  path: string;
  group: DnFieldGroup;
  inputType: DnInputType;
  required: boolean;
  labelKey: string;
}

export const DN_FIELD_SCHEMA: DnFieldDef[] = [
  // root
  { path: 'deliveryNoteId',    group: 'root', inputType: 'text',   required: true,  labelKey: 'analytics.deliveryNote.labels.deliveryNoteId' },
  { path: 'manufacturingDate', group: 'root', inputType: 'date',   required: true,  labelKey: 'analytics.deliveryNote.labels.manufacturingDate' },
  { path: 'manufacturingTime', group: 'root', inputType: 'time',   required: true,  labelKey: 'analytics.deliveryNote.labels.manufacturingTime' },
  { path: 'volume',            group: 'root', inputType: 'number', required: true,  labelKey: 'analytics.deliveryNote.labels.volume' },
  { path: 'truckLicensePlate', group: 'root', inputType: 'text',   required: false, labelKey: 'analytics.deliveryNote.labels.truckLicensePlate' },

  // concreteMetadata (all required)
  { path: 'concreteMetadata.concreteType',     group: 'concreteMetadata', inputType: 'text',   required: true, labelKey: 'analytics.deliveryNote.labels.concreteType' },
  { path: 'concreteMetadata.cementContent',    group: 'concreteMetadata', inputType: 'number', required: true, labelKey: 'analytics.deliveryNote.labels.cementContent' },
  { path: 'concreteMetadata.waterCementRatio', group: 'concreteMetadata', inputType: 'number', required: true, labelKey: 'analytics.deliveryNote.labels.waterCementRatio' },

  // mixer (all optional)
  { path: 'mixer.mixer_name', group: 'mixer', inputType: 'text', required: false, labelKey: 'analytics.deliveryNote.labels.mixerName' },
  { path: 'mixer.mixer_id',   group: 'mixer', inputType: 'text', required: false, labelKey: 'analytics.deliveryNote.labels.mixerId' },
];
